import axios from "axios";
import getDomain from "helpers/getDomain";

export const api = axios.create({
    baseURL: `${getDomain()}/api`,
    withCredentials: true,
    headers: {
        "App-Ver": process.env.REACT_APP_VERSION,
    },
});

export const accounts = axios.create({
    baseURL: `${process.env.REACT_APP_DOMAIN_ACCOUNTS}`,
    withCredentials: true,
});

export const web = axios.create({
    baseURL: `${getDomain()}/api/public`,
    withCredentials: true,
    headers: {
        "App-Ver": process.env.REACT_APP_VERSION,
    },
});
